import { IconLoading } from '@/assets/icons/icon-loading'
import BurgerMenu from '@/assets/icons/icon-menu.svg'
import { CreatorHeroLogo } from '@/components/layout/header/logo.tsx'

export const LoadingPageContent = () => {
  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 flex h-[72px] flex-shrink-0 items-center justify-between gap-2 border-b bg-card pl-8 pr-9 lg:pr-16">
        <BurgerMenu className="cursor-pointer lg:hidden" />
        <CreatorHeroLogo width={150} />
        <span className="ml-auto h-10 w-32 animate-pulse rounded-lg bg-skeleton">
          &nbsp;
        </span>
        <span className="h-10 w-40 animate-pulse rounded-lg bg-skeleton">
          &nbsp;
        </span>
      </header>
      <div className="relative h-full flex-1 pt-[72px]">
        <IconLoading className="absolute left-1/2 top-1/2 h-8 w-8 animate-spin" />
      </div>
    </>
  )
}
